<template>
  <b-dropdown
    v-if="empresas.length > 1"
    class="empresa-selector"
    size="sm"
    variant="link"
    toggle-class="empresa-selector__toggle text-decoration-none"
    right
    no-flip
  >
    <template v-slot:button-content>
      <span class="svg-icon svg-icon-lg empresa-selector__icon">
        <inline-svg src="media/svg/icons/Home/Building.svg" />
      </span>
      <span class="empresa-selector__text">
        <small>Empresa atual</small>
        <strong>{{ empresaAtualNome }}</strong>
      </span>
      <span
        v-if="trocando"
        class="spinner spinner-sm spinner-light ml-2"
        aria-label="Trocando empresa"
      ></span>
    </template>

    <b-dropdown-header>Trocar de empresa</b-dropdown-header>
    <div
      v-for="empresa in empresas"
      :key="empresa.id_empresa"
      class="empresa-selector__option"
    >
      <button
        type="button"
        class="dropdown-item empresa-selector__company-button"
        :class="{ active: isEmpresaAtual(empresa) }"
        :disabled="trocando || isEmpresaAtual(empresa)"
        @click="selecionarEmpresa(empresa)"
      >
        <span class="empresa-selector__option-name">
          {{ nomeEmpresa(empresa) }}
        </span>
        <span class="d-flex align-items-center ml-3">
          <span
            v-if="isEmpresaPadrao(empresa)"
            class="badge badge-light-warning mr-2"
          >
            Padrão
          </span>
          <span v-if="empresa.tipo_grupo" class="badge badge-light">
            {{ tipoEmpresa(empresa) }}
          </span>
        </span>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-icon empresa-selector__default-button"
        :class="isEmpresaPadrao(empresa) ? 'btn-light-warning' : 'btn-light'"
        :disabled="salvandoPadrao || isEmpresaPadrao(empresa)"
        :title="
          isEmpresaPadrao(empresa)
            ? 'Empresa padrão'
            : 'Definir como empresa padrão'
        "
        :aria-label="
          isEmpresaPadrao(empresa)
            ? `${nomeEmpresa(empresa)} é a empresa padrão`
            : `Definir ${nomeEmpresa(empresa)} como empresa padrão`
        "
        @click="definirEmpresaPadrao(empresa)"
      >
        <i
          class="fas fa-star"
          :class="isEmpresaPadrao(empresa) ? 'text-warning' : 'text-muted'"
        ></i>
      </button>
    </div>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import {
  SELECT_EMPRESA,
  UPDATE_EMPRESA_PADRAO,
} from "@/core/services/store/auth.module";

export default {
  name: "EmpresaSelector",
  data() {
    return {
      trocando: false,
      salvandoPadrao: false,
    };
  },
  computed: {
    ...mapGetters(["empresas", "empresaContexto", "empresaPadraoId"]),
    empresaAtualId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
    empresaAtual() {
      return (
        this.empresas.find((empresa) => this.isEmpresaAtual(empresa)) || null
      );
    },
    empresaAtualNome() {
      return this.empresaAtual
        ? this.nomeEmpresa(this.empresaAtual)
        : "Selecionar";
    },
  },
  methods: {
    nomeEmpresa(empresa) {
      return (
        empresa?.nome_fantasia ||
        empresa?.nome ||
        `Empresa ${empresa?.id_empresa}`
      );
    },
    tipoEmpresa(empresa) {
      return empresa?.tipo_grupo === "MATRIZ" ? "Matriz" : "Filial";
    },
    isEmpresaAtual(empresa) {
      return Number(empresa?.id_empresa) === this.empresaAtualId;
    },
    isEmpresaPadrao(empresa) {
      return Number(empresa?.id_empresa) === Number(this.empresaPadraoId || 0);
    },
    async definirEmpresaPadrao(empresa) {
      if (this.salvandoPadrao || this.isEmpresaPadrao(empresa)) return;

      this.salvandoPadrao = true;

      try {
        await this.$store.dispatch(UPDATE_EMPRESA_PADRAO, {
          id_empresa: Number(empresa.id_empresa),
        });
        this.$toast.success(
          `${this.nomeEmpresa(empresa)} definida como empresa padrão.`
        );
      } finally {
        this.salvandoPadrao = false;
      }
    },
    async selecionarEmpresa(empresa) {
      if (this.trocando || this.isEmpresaAtual(empresa)) return;

      this.trocando = true;

      try {
        await this.$store.dispatch(SELECT_EMPRESA, {
          id_empresa: Number(empresa.id_empresa),
        });
        this.$toast.success(
          `Empresa alterada para ${this.nomeEmpresa(empresa)}.`
        );
        window.location.reload();
      } finally {
        this.trocando = false;
      }
    },
  },
};
</script>

<style lang="scss">
.empresa-selector {
  align-self: center;
  margin-right: 0.75rem;

  .empresa-selector__toggle {
    align-items: center;
    color: #fff;
    display: flex;
    max-width: 260px;
    padding: 0.45rem 0.75rem;
  }

  .empresa-selector__icon svg g [fill] {
    fill: #fff;
  }

  .empresa-selector__text {
    display: flex;
    flex-direction: column;
    line-height: 1.15;
    margin-left: 0.55rem;
    min-width: 0;
    text-align: left;

    small {
      opacity: 0.75;
    }

    strong {
      max-width: 190px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .dropdown-menu {
    min-width: 280px;
    padding: 0.5rem 0;
  }

  .empresa-selector__option-name {
    max-width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .empresa-selector__option {
    align-items: stretch;
    display: flex;
    padding: 0 0.5rem;
  }

  .empresa-selector__company-button {
    align-items: center;
    border-radius: 0.42rem 0 0 0.42rem;
    display: flex;
    justify-content: space-between;
    min-width: 0;
    padding-left: 0.75rem;
  }

  .empresa-selector__default-button {
    border-radius: 0 0.42rem 0.42rem 0;
    flex: 0 0 38px;
    margin-bottom: 0.15rem;
    margin-top: 0.15rem;
  }
}

@media (max-width: 767.98px) {
  .empresa-selector {
    .empresa-selector__toggle {
      max-width: 180px;
    }

    .empresa-selector__text strong {
      max-width: 110px;
    }
  }
}
</style>
